/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderDto } from '../../models/create-order-dto';
import { PosOrder } from '../../models/pos-order';

export interface PosOrdersControllerCreate$Params {
      body: CreateOrderDto
}

export function posOrdersControllerCreate(http: HttpClient, rootUrl: string, params: PosOrdersControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PosOrder>> {
  const rb = new RequestBuilder(rootUrl, posOrdersControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosOrder>;
    })
  );
}

posOrdersControllerCreate.PATH = '/pos/orders';
